import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

export const useDataInvalidation = <T>(commonTags?: T | T[]) => {
  const queryClient = useQueryClient();

  return useCallback(
    (currentTags?: T | T[]) => {
      const tags = commonTags || currentTags;
      const queryKey = Array.isArray(tags) ? tags : [tags];
      return queryClient.invalidateQueries({ queryKey });
    },
    [queryClient, commonTags],
  );
};
